// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://k81hzyj1yb.execute-api.eu-west-2.amazonaws.com/v0',
  ENDPOINTS: {
    SESSION: '/session',
    LEADERBOARD: '/leaderboard',
    DRINK: '/drink',
    PUB: '/pub',
    CRAWLS: '/crawls'
  }
} as const;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string, queryParams?: Record<string, string>): string => {
  let url = `${API_CONFIG.BASE_URL}${endpoint}`;
  
  if (queryParams) {
    const searchParams = new URLSearchParams(queryParams);
    url += `?${searchParams.toString()}`;
  }
  
  return url;
};

// Pre-built URLs for common endpoints
export const API_URLS = {
  SESSION: (sessionId: string) => buildApiUrl(`${API_CONFIG.ENDPOINTS.SESSION}/${sessionId}`),
  FINISH_SESSION: (sessionId: string) => buildApiUrl(`${API_CONFIG.ENDPOINTS.SESSION}/${sessionId}/finish`),
  RESUME_SESSION: (code: string) => buildApiUrl(`${API_CONFIG.ENDPOINTS.SESSION}/resume/${encodeURIComponent(code)}`),
  LEADERBOARD: (crawlId: string) => buildApiUrl(`${API_CONFIG.ENDPOINTS.LEADERBOARD}/${crawlId}`),
  CREATE_SESSION: () => buildApiUrl(API_CONFIG.ENDPOINTS.SESSION),
  DRINK: () => buildApiUrl(API_CONFIG.ENDPOINTS.DRINK),
  PUB: (pubId: string) => buildApiUrl(`${API_CONFIG.ENDPOINTS.PUB}/${pubId}`),
  CRAWLS: () => buildApiUrl(API_CONFIG.ENDPOINTS.CRAWLS)
} as const;

// Mapbox Configuration
export const MAPBOX_CONFIG = {
  ACCESS_TOKEN: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
  DEFAULT_STYLE: 'mapbox://styles/mapbox/standard',
  DEFAULT_CENTER: [-1.288, 52.877] as [number, number],
  DEFAULT_ZOOM: 13
};
